import { render, staticRenderFns } from "./TotalPriceEligibility.vue?vue&type=template&id=2d53de1c"
import script from "./TotalPriceEligibility.vue?vue&type=script&lang=js"
export * from "./TotalPriceEligibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports